import * as React from "react"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Typography from "@mui/material/Typography"
import Modal from "@mui/material/Modal"
import { Divider } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import {
  ButtonContainer,
  CancelButton,
  ConfirmButton,
  ModalHeader,
} from "./Atom"
import { useSelector } from "react-redux"
import { modalContainerStyles } from "../Atom"

const MetricConfirmation = (props: any) => {
  const {
    open,
    setOpen,
    handleCreateNewMetric,
    setTypeNewMetricName,
    setNewMetricName,
    newMetricName,
    editMetric,
    setCurrentActiveEditMetricName,
    handleMetricNameChangeSubmit,
    delMetric,
    handleMetricDelete,
    type,
  } = props

  const handleClose = () => {
    if (type == "new") {
      setTypeNewMetricName(false)
      setNewMetricName("")
    } else if (type == "edit") {
      setCurrentActiveEditMetricName(-1)
    } else if (type == "del") {
    }

    setOpen(false)
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={modalContainerStyles}>
        <ModalHeader>
          <CloseIcon
            sx={{ marginRight: "10px", marginTop: "10px", cursor: "pointer" }}
            onClick={() => {
              handleClose()
            }}
          />
        </ModalHeader>

        <Typography
          id="modal-modal-title"
          fontSize={"18px"}
          fontWeight={500}
          sx={{
            padding: "10px 10px 30px 10px",
            textAlign: "center",
            borderBottom: "1px solid grey",
          }}
        >
          {type == "new" ? (
            <>
              Are you sure to create a new metric with a name{" "}
              <b>{`"${newMetricName}"`}</b>?
            </>
          ) : type == "edit" ? (
            <>
              Are you sure to rename the metric from{" "}
              <b>{`"${editMetric?.oldMetricName}"`}</b> to{" "}
              <b>{`"${editMetric?.metricName}"`}</b>?
            </>
          ) : type == "del" ? (
            <>
              Are you sure to delete the metric{" "}
              <b>{`"${delMetric?.metricName}"`}</b>?
            </>
          ) : (
            <></>
          )}
        </Typography>

        <br />
        {/* <Divider /> */}

        <ButtonContainer>
          <CancelButton onClick={() => handleClose()}>
            <Typography color={"#4A79E7"}>Cancel</Typography>
          </CancelButton>
          <ConfirmButton
            onClick={() => {
              type == "new"
                ? handleCreateNewMetric()
                : type == "edit"
                ? handleMetricNameChangeSubmit(editMetric?.metricId)
                : type == "del"
                ? handleMetricDelete(delMetric?.metricId)
                : ""
              handleClose()
            }}
          >
            <Typography color={"#ffffff"}>Yes</Typography>
          </ConfirmButton>
        </ButtonContainer>
      </Box>
    </Modal>
  )
}

export default MetricConfirmation
